/**
 * @desc 根据入参条件查询相关物料信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.MaterialConditionRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.MaterialInfoDTO>>> {
  return defHttp.post({
    url: '/web/material/query',
    data,
  });
}

export function mock(
  data: defs.MaterialConditionRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.MaterialInfoDTO>>> {
  return defHttp.post({
    url: '/mock/web/material/query',
    data,
  });
}
